module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-Regular.861e3874.woff2";